import { useState, useEffect } from "react";

interface Props {
    option: any;
    onChange: any;
    index: any;
}

const HeaderMultiSelectItem = (props: Props) => {

    const [option, setOption] = useState(props.option);

    useEffect(() => {
        setOption(props.option);
    }, [option]);

    const handleChange = () => {
        const newOption = option;
        newOption.selected = !option.selected;
        setOption(newOption);
        props.onChange(newOption);
    }

    return <div className="header-option" key={`header-option${props.index}`}>
        <input type="checkbox" checked={option.selected} onChange={handleChange}></input>
        <span onClick={handleChange}>{option.name}</span>
    </div>
}

export default HeaderMultiSelectItem;